/* eslint-disable */
import axiosInstance from "@/composables/axios-instance.js";
import router from "@/router/index.js";
import { toast } from "vue3-toastify";

const state = {
  personalRequirements: {},
  educationalRequirements: {},
  resumeRequirements: {},
  personalData: {},
  educationalData: {},
  resumeData: {},
};

const getters = {
  getPersonalRequirements(state) {
    return state.personalRequirements;
  },
  getEducationalRequirements(state) {
    return state.educationalRequirements;
  },
  getResumeRequirements(state) {
    return state.resumeRequirements;
  },
  getPersonalData(state) {
    return state.personalData;
  },
  getEducationlData(state) {
    return state.educationalData;
  },
  getResumeData(state) {
    return state.resumeData;
  },
};

const mutations = {
  setPersonalRequirements(state, info) {
    state.personalRequirements = info;
  },
  setEducationalRequirements(state, info) {
    state.educationalRequirements = info;
  },
  setResumeRequirements(state, info) {
    state.resumeRequirements = info;
  },
  setPersonalData(state, data) {
    state.personalData = data;
  },
  setEducationalData(state, data) {
    state.educationalData = data;
  },
  setResumeData(state, data) {
    state.resumeData = data;
  },
};

const actions = {
  getPersonalRequirementsFromApi({ commit }) {
    return axiosInstance
      .get("/preferences/personal-info/")
      .then(response => {
        commit("setPersonalRequirements", response.data);
      })
      .catch(error => {
        console.error(error);
      });
  },

  getPersonalDataFromApi({ commit }, username) {
    return axiosInstance
      .get("/account/personal-data/detail/", { params: { username } })
      .then(response => {
        commit("setPersonalData", response.data);
      })
      .catch(error => {
        commit("setPersonalData", {});
        console.error(error);
      });
  },

  createPersonalInfo({ rootState }, data) {
    let info = {};
    for (let i in data) {
      if (data[i])
        info[i] = data[i];
    }
    return axiosInstance
      .postForm("/account/personal-data/create/", info)
      .then(() => {
        rootState.user.userData.have_personal_info = true;
        router.push({ name: "profile-educational", query: { username: info.username } });
      })
      .catch(error => {
        console.error(error);
        toast.error("اطلاعات را به درستی وارد کنید");
      });
  },

  updatePersonalInfo({ }, data) {
    let info = {};
    for (let i in data) {
      if (data[i])
        info[i] = data[i];
    }
    return axiosInstance
      .put("/account/personal-data/update/", info)
      .then(() => {
        router.push({ name: "profile-educational",  query: { username: info.username } });
      })
      .catch(error => {
        console.error(error);
        toast.error("اطلاعات را به درستی وارد کنید");
      });
  },

  getEducationalRequirementsFromApi({ commit }) {
    return axiosInstance
      .get("/preferences/education-catalog/")
      .then(response => {
        commit("setEducationalRequirements", response.data);
      })
      .catch(error => {
        console.error(error);
      });
  },

  getEducationalDataFromApi({ commit }, username) {
    return axiosInstance
      .get("/account/education-catalog/detail/", { params: { username } })
      .then(response => {
        commit("setEducationalData", response.data);
      })
      .catch(error => {
        console.error(error);
      });
  },

  createEducationalInfo({ rootState }, data) {
    let info = {};
    for (let i in data) {
      if (data[i])
        info[i] = data[i];
    }
    return axiosInstance
      .post("/account/education-catalog/create/", info)
      .then(() => {
        rootState.user.userData.have_education_catalog = true;
        router.push({ name: "profile-resume" });
      })
      .catch(error => {
        console.error(error);
        toast.error("اطلاعات را به درستی وارد کنید");
      });
  },

  updateEducationalInfo({ }, data) {
    let info = {};
    for (let i in data) {
      if (data[i] != null)
        info[i] = data[i];
    }
    return axiosInstance
      .put("/account/education-catalog/update/", info)
      .then(() => {
        router.push({ name: "profile-resume" });
      })
      .catch(error => {
        console.error(error);
        toast.error("اطلاعات را به درستی وارد کنید");
      });
  },
  
  getResumeRequirementsFromApi({ commit }) {
    return axiosInstance
      .get("/preferences/experience-catalog/")
      .then(response => {
        commit("setResumeRequirements", response.data);
      })
      .catch(error => {
        console.error(error);
      });
  },

  getResumeDataFromApi({ commit }, username) {
    return axiosInstance
      .get("/account/experience-catalog/detail/", { params: { username } })
      .then(response => {
        commit("setResumeData", response.data);
      })
      .catch(error => {
        console.error(error);
      });
  },

  createResumeInfo({ rootState }, data) {
    let resume = {};
    for (let i in data) {
      if (data[i])
        resume[i] = data[i];
    }
    return axiosInstance
      .post("/account/experience-catalog/create/", resume)
      .then(() => {
        rootState.user.userData.have_experience_catalog = true;
        toast.success("پروفایل شما با موفقیت تکمیل شد");
        toast("در حال انتقال به صفحه موقعیت‌های شغلی");
        setTimeout(() => {
          router.push({ name: "jobs", query: { username: resume.username } });
        }, 3000);
      })
      .catch(error => {
        console.error(error);
        toast.error("اطلاعات را به درستی وارد کنید");
      });
  },

  updateResumeInfo({ }, data) {
    let resume = {};
    for (let i in data) {
      if (data[i])
        resume[i] = data[i];
    }
    return axiosInstance
      .put("/account/experience-catalog/update/", resume)
      .then(() => {
        toast.success("اطلاعات شما با موفقیت تغییر یافت");
        toast("در حال انتقال به صفحه موقعیت‌های شغلی");
        setTimeout(() => {
          router.push({ name: "jobs", query: { username: resume.username } });
        }, 3000);
      })
      .catch(error => {
        console.error(error);
        toast.error("اطلاعات را به درستی وارد کنید");
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
